import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FintechAddComponent} from "../fintech-add/fintech-add.component";
import {StripeCardElement, StripeElements} from "@stripe/stripe-js";
import {FintechService} from "../../../../services/fintech.service";
import {HttpClient} from "@angular/common/http";
import {FormBuilder} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {Observable, of, switchMap} from "rxjs";

@Component({
  selector: 'app-add-stripe',
  templateUrl: './fintech-add-stripe.component.html',
  styleUrl: './fintech-add-stripe.component.scss'
})
export class FintechAddStripeComponent extends FintechAddComponent implements OnInit {

    @ViewChild('cardElement') cardElementRef: ElementRef;
    elements: StripeElements | null = null;
    card: StripeCardElement | null = null;


    constructor(fintechService: FintechService,
                http: HttpClient,
                formBuilder: FormBuilder,
                changeDetectorRef: ChangeDetectorRef,
                private dialogRef: MatDialogRef<FintechAddStripeComponent>
                ) {
        super(fintechService, http, formBuilder, changeDetectorRef);
    }

    ngOnInit(): void {
        this.cardInfoChanged = false;
        this.changeDetectorRef.detectChanges();
        this.elements = this.fintechService.stripe.elements();
        this.card = this.elements.create('card', {
            hidePostalCode: true, // Always hide the postal code field
        });
        this.card.mount(this.cardElementRef.nativeElement);
        this.card.on('change', () => {
            this.cardInfoChanged = true;
        });

    }


    onBillingCancel() {
        this.dialogRef.close(null);
    }


    onBillingSubmit() {
        this.payMethodInfo.cardholder =  this.billForm.value.cardholder;
        this.payMethodInfo.address1 =  this.billForm.value.address1;
        this.payMethodInfo.address2 =  this.billForm.value.address2;
        this.payMethodInfo.city =  this.billForm.value.city;
        this.payMethodInfo.state =  this.billForm.value.state;
        this.payMethodInfo.postalCode =  this.billForm.value.postalCode;
        this.payMethodInfo.country =  this.billForm.value.country;


        this.messageColor = "white";
        this.billMessage = "Please wait updating....";
        this.fintechService.setBusy(true);
        let stripeIntentId;

        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap( payerToken => {
                const url = "https://pay.signage.me:8443/stripe/createStripeIntent";
                const options = {token: payerToken};
                return this.http.post(url, options)
            }),
            switchMap(ret => {
                const data: any = ret;
                stripeIntentId = data.stripeIntentId;

                return new Observable<any>( sub => {
                    this.fintechService.stripe.confirmCardSetup(data.clientSecret, {
                        payment_method: {
                            card: this.card,
                            billing_details: {
                                name: this.payMethodInfo.cardholder,
                                address: {
                                    line1: this.payMethodInfo.address1,
                                    line2: this.payMethodInfo.address2,
                                    city: this.payMethodInfo.city,
                                    state: this.payMethodInfo.state,
                                    postal_code: this.payMethodInfo.postalCode,
                                    country: this.payMethodInfo.country
                                }
                            }
                        }
                    }).then( ret => {
                        sub.next(ret);
                        sub.complete();
                    }).catch((error) => {
                        // Handle network or other errors
                        console.error('Error confirming card setup:', error);
                        sub.error();
                    });
                });
            }),
            switchMap( ret => {
                if (ret.error) {
                    this.messageColor = "#ffc0c0";
                    this.billMessage = ret.error.message;
                    this.fintechService.setBusy(false);
                    return of(null);
                } else {
                    return this.updateStripeBilling(stripeIntentId);
                }
            })
        );

        obs$.subscribe();
    }


    updateStripeBilling(intentId): Observable<any> {
        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap( payerToken => {
                const url = "https://pay.signage.me:8443/stripe/updateStripeBilling";
                const options = {token: payerToken, stripeIntentId: intentId};
                return this.http.post(url, options);
            }),
            switchMap(ret => {
                this.fintechService.data.recurringPayMethodId = (<any>ret).recurringPayMethodId;
                this.fintechService.data.orderPayMethodId = (<any>ret).orderPayMethodId;


                const payMethodInfo: any = (<any>ret).payMethodInfo;
                this.payMethodInfo.payMethodId = payMethodInfo.payMethodId;
                this.payMethodInfo.cardholder = payMethodInfo.cardholder;
                this.payMethodInfo.last4 = payMethodInfo.last4;
                this.payMethodInfo.expiration = payMethodInfo.expiration;
                this.payMethodInfo.address1 = payMethodInfo.address1;
                this.payMethodInfo.address2 = payMethodInfo.address2;
                this.payMethodInfo.city = payMethodInfo.city;
                this.payMethodInfo.state = payMethodInfo.state;
                this.payMethodInfo.postalCode = payMethodInfo.postalCode;
                this.payMethodInfo.country = payMethodInfo.country;
                this.messageColor = "white";
                this.billMessage = "";
                this.dialogRef.close(this.payMethodInfo);
                this.fintechService.setBusy(false);
                return of('a');
            })
        );
        return obs$;
    }
}
